import { ContentItem } from '../../shared/interfaces';

// A completion and replay refer to one attempt; a retry has its own call id.
export function applyToolDiscovery(content: ContentItem[], payload: any): ContentItem[] {
  if (!payload || typeof payload.tool_call_id !== 'string' || !payload.tool_call_id ||
      !['loading', 'loaded', 'empty', 'error'].includes(payload.status)) return content;
  const index = content.findIndex((item: any) => item.type === 'tool_action' &&
    item.tool === 'tool_discovery' && item.args?.[0]?.tool_call_id === payload.tool_call_id);
  const previous: any = index >= 0 ? content[index] : undefined;
  if (previous && previous.args?.[0]?.status !== 'loading' && payload.status === 'loading') return content;
  const item: ContentItem = { type: 'tool_action', tool: 'tool_discovery',
    queries: [payload.query || 'Ferramentas'], args: [payload], pending: payload.status === 'loading' };
  if (index < 0) return [...content, item];
  return content.map((old, i) => i === index ? item : old);
}
